import styled from '@emotion/styled/macro'

export const Title = styled('h2')`
    display: flex;
    font-size: 1.25rem;
    box-sizing: border-box;
    background-color: ${({
        backgroundColor = 'var(--colors-primary-accent)',
    }) => backgroundColor};
    text-align: center;
    justify-content: space-between;
    align-items: center;
    padding: 0.25em;
    margin: 0;
    width: 100%;
    border-bottom: var(--borders-main);
    svg {
        height: 1.25em;
    }
`
export const TitleMenu = styled('div')`
    min-height: 3rem;
    display: flex;
    align-items: end;
    justify-content: space-around;
    padding-top: 1rem;
    > * {
        border: var(--borders-main);
        border-bottom: none;
        border-radius: var(--borderRadius-sm) var(--borderRadius-sm) 0 0;
        padding: 0.5rem;
        text-decoration: none;
        margin-left: 0.5rem;
        &.active {
            font-weight: bold;
            margin-bottom: -0.075rem;
            background-color: ${({
                activeTabColor = 'var(--colors-grays-0)',
            }) => activeTabColor};
        }
        font-size: 1rem;
    }
`
export const TitleContainer = styled('div')`
    display: flex;
    box-sizing: border-box;
    ${({ hasMenu }) => (hasMenu ? 'flex-direction: column;' : '')};
    background-color: ${({
        backgroundColor = 'var(--colors-primary-accent)',
    }) => backgroundColor};
    text-align: center;
    justify-content: space-between;
    align-items: center;
    padding: ${({ hasMenu }) => (hasMenu ? '0.5em 0.5em 0 0.5em' : '0.5em')};
    margin: 0;
    width: 100%;
    border-bottom: var(--borders-main);
    svg {
        height: 1.25em;
    }
`
